import config from 'config/Config';
import BaseApi from './BaseApi';
import { RequestPermissions } from 'types/store/normalized';

export class RequestPermissionsApi extends BaseApi<RequestPermissions> {
  constructor() {
    super(`${config.get('backendURL')}v2/requests/request-permissions/query`);
  }
}
